// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-underscore-dangle, multiline-comment-style */
import { get } from "@kiwicom/frontend-common/utils/get"
import cuckoo from "@kiwicom/frontend-common/services/cuckoo/cuckoo"

import { getTrackingEventFromAction } from "../tracking/actionTypesToEventsMapper"
import type { TrackedEventTypes } from "../tracking/actionTypesToEventsMapper"
import { mapActionTypeToDataDogEventName } from "../datadog/datadogMapper"
import { cleanFilesForPayloadTracking } from "../../scenes/Booking/components/BookingFileUpload/BookingFileUploadHelpers"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default () => (next: (arg1?: any) => any) => (action: {
  type: TrackedEventTypes | string
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  original_type: string
  _track?: {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value?: any
    event: string
  }
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action?: any
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  res?: any
}) => {
  // FIXME: JS doesn't have a concept of public and private, so don't use dangling underscores if possible

  const track = action._track

  if (track) {
    const eventFromDictionary = getTrackingEventFromAction(action)

    if (eventFromDictionary) {
      const event = {
        category: eventFromDictionary.module,
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        detail: eventFromDictionary.detail || undefined,
        /* $FlowFixMe This comment suppresses an error found when upgrading
         * Flow to v0.118.0. To view the error, delete this comment and run
         * Flow. */
        ...eventFromDictionary.action,
      } as const

      // @ts-expect-error: Flow to TS migration.
      if (action.type.endsWith("_REQUEST")) {
        cuckoo.track(
          { ...event, action: `${event.action} requested` },
          cleanFilesForPayloadTracking(track),
        )
        // @ts-expect-error: Flow to TS migration.
      } else if (action.type.endsWith("_FAILURE")) {
        cuckoo.track({ ...event, action: `${event.action} failed` }, track)
        // @ts-expect-error: Flow to TS migration.
      } else if (action.type.endsWith("_SUCCESS")) {
        cuckoo.track({ ...event, action: `${event.action} succeeded` }, {})
      } else {
        cuckoo.track(event, cleanFilesForPayloadTracking(track))
      }
    } else {
      // @ts-expect-error: Flow to TS migration.
      const eventName = mapActionTypeToDataDogEventName(action) || action.type

      if (typeof track === "string" && track[0] === "@") {
        // @ts-expect-error: Flow to TS migration.
        const payload = get([track.substring(1)], action)
        cuckoo.track(String(eventName), payload)
      } else {
        cuckoo.track(String(eventName), cleanFilesForPayloadTracking(track))
      }
    }
  }

  // dispatch the original action
  return next(action)
}
